import CountDown from './index.vue'
export default CountDown;


// WEBPACK FOOTER //
// ./src/components/CountDown/index.js